import * as CONSTANTS from 'common/constants/analyst-dashboards';

export const columns = [
  {
    id: CONSTANTS.COMPANY_NAME_KEY,
    label: CONSTANTS.COMPANY_NAME,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.STATUS_KEY,
    label: CONSTANTS.STATUS,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.NOTES_KEY,
    label: CONSTANTS.NOTES,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.OTHER_CONSULTANT_KEY,
    label: CONSTANTS.OTHER_CONSULTANT,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ENGAGEMENT_MANAGER_KEY,
    label: CONSTANTS.ENGAGEMENT_MANAGER,
    isSortable: false,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.VALUATION_DATE_KEY,
    label: CONSTANTS.VALUATION_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.VALUATION_FEE_KEY,
    label: CONSTANTS.VALUATION_FEE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
];
